import { keys } from '@rehaje/shared'

import type { JavaScriptImports } from './types'

export function createCompiledFunctionByRunner(runner: Function) {
  return function (variables: any) {
    return function (...args: any[]) {
      return runner(variables, ...args)
    }
  }
}

export function loadImports(
  imports: JavaScriptImports,
  loadModules?: string[],
  onNotResolved?: (imports: JavaScriptImports, name: string) => void
):
  | { hasPromise: false; imports: Record<string, object> }
  | { hasPromise: true; imports: Promise<Record<string, object>> } {
  loadModules ??= keys(imports)
  const loadTasks: Promise<void>[] = []
  loadModules.forEach((name) => {
    let module = imports[name]
    if (typeof module === 'function') {
      module = module()
      imports[name] = module
    }
    if (module instanceof Promise) {
      loadTasks.push(
        module.then((module) => {
          imports[name] = module
        })
      )
    }
    if (typeof module !== 'object' || module == null) {
      onNotResolved?.(imports, name)
    }
  })
  const hasPromise = loadTasks.length > 0
  return hasPromise
    ? { hasPromise, imports: Promise.all(loadTasks).then(() => imports) }
    : { hasPromise, imports }
}
